<template>
  <div
    data-testid="udi-item"
    class="flex items-center gap-4"
    :class="{ 'justify-end': isLabelIdentificationKey }"
  >
    <img
      v-if="!isLabelIdentificationKey"
      data-testid="udi-item-icon"
      :src="iconMap[udiKey] ?? ''"
      :alt="udiKey"
      class="h-[42px] w-[42px]"
    />
    <div
      data-testid="udi-item-text-container"
      class="flex flex-wrap text-sm whitespace-pre-line"
      :class="isError ? 'text-[#D92D20]' : 'text-tree-item'"
    >
      <span v-if="typeof displayedText === 'string'" data-testid="udi-item-text">
        {{ displayedText }}
      </span>
      <template v-else>
        <span
          v-for="(fragment, index) in displayedText"
          :key="index"
          data-testid="udi-item-fragment"
        >
          {{ fragment }}
        </span>
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import IconCE from '@/assets/ce.svg'
import IconCatalogNumber from '@/assets/catalog-number.svg'
import IconDateOfManufacture from '@/assets/date-of-manufacture.svg'
import IconManufacturer from '@/assets/manufacturer.svg'
import IconMedicalDevice from '@/assets/medical-device.svg'
import IconUniqueProductIdentification from '@/assets/unique-product-identification.svg'
import IconInstructionsForUse from '@/assets/instructions-for-use.svg'
import IconCaution from '@/assets/caution.svg'
import type { PluginUdiDto } from '@/generated'

const { t } = useI18n()

const props = defineProps<{
  udiKey: keyof PluginUdiDto
  text?: string | string[] | null
  isError?: boolean
}>()

const isLabelIdentificationKey = computed(() => props.udiKey === 'labelIdentification')

const displayedText = computed(() => {
  if (props.isError) {
    return t('Loading failed')
  }
  return props.text || ''
})

const iconMap: Partial<Record<keyof PluginUdiDto, string>> = {
  ceMark: IconCE,
  instructionsForUse: IconInstructionsForUse,
  caution: IconCaution,
  type: IconMedicalDevice,
  productName: IconCatalogNumber,
  dateOfManufacture: IconDateOfManufacture,
  manufacturer: IconManufacturer,
  udi: IconUniqueProductIdentification
}
</script>
